import { ContainerDefinitionType, makeContainerDefinition } from '../definitions';
import { TELADOC_CONTAINER_KEYS } from './containerKeys/containerKeys';
import { IDashboardVariationConfig } from './types';

export const TELADOC_DASHBOARD_CONFIG: IDashboardVariationConfig = {
    containers: [
        makeContainerDefinition({
            type: ContainerDefinitionType.UNASSIGNED,
            key: TELADOC_CONTAINER_KEYS.unassigned,
            defaultEnabled: true,
        }),
        makeContainerDefinition({
            type: ContainerDefinitionType.SHIFT_BLOCK_SYNC_ISSUES,
            key: TELADOC_CONTAINER_KEYS.shiftBlockSyncIssues,
            defaultEnabled: true,
        }),
    ],
};
